// 类型
export enum ASSIGN_LIST_TYPE {
  /**
   * 规则直选
   */
  RULES = 1,
}

export const ASSIGNTYPEENUM = {
  [ASSIGN_LIST_TYPE.RULES]: '规则直选',
};

export enum PRO_ASSIGN_LIST_TYPE {
  /**
   * 规则直选
   */
  RULES = 5,
  /**
   * 分配提报
   */
  ASSIGN1 = 1,
  ASSIGN2 = 2,
}

export const PROASSIGNTYPEENUM = {
  [PRO_ASSIGN_LIST_TYPE.ASSIGN1]: '分配提报',
  [PRO_ASSIGN_LIST_TYPE.ASSIGN2]: '分配提报',
  [PRO_ASSIGN_LIST_TYPE.RULES]: '规则直选',
};

// 日常活动的enum
export enum ACT_ASSIGN_LIST_TYPE {
  /**
   * 规则圈选
   */
  RULES = 1,
}

export const ACTASSIGNTYPEENUM = {
  [ACT_ASSIGN_LIST_TYPE.RULES]: '规则圈选',
};

export enum PROMO_LIST_TYPE {
  /**
   * 跨店铺大促黑名单模式
   */
  BLACK_MODEL = 101,
  /**
   * 跨店铺大促白名单模式
   */
  WHITE_MODEL = 102,
  /**
   * 商品打标模式
   */
  MARK_MODEL = 103,
  /**
   * 预告价模式
   */
  ADVANCE_PRICE_MODEL = 104,
  /**
   * 跨店铺模式
   */
  CROSS_SHOP_ACTIVITY = 105,
  /**
   * 大促盘货模式
   */
  SMART_STOCK_MODEL = 106,

  /**
   * 平台级促销模式
   */
  PLATFORM_PROMOTION_MODEL = 107,
  /**
   * 优惠券模式
   */
  COUPON_MODEL = 108,
  /**
   * 自营总价促销
   */
  SELF_PROMOTION_MODEL = 109,
  /**
   * 折扣促销
   */
  PLUS_BRAND_PROMOTION_MODEL = 110,
  /**
   * 膨胀金
   */
  EXPANSION_GOLD_MODEL = 111,
  /**
   * 限时限量
   */
  PROMO_LIMIT_MODEL = 112,
  /**
   * 赠品促销
   */
  LARGESS_MODEL = 116,
  // 送礼折扣
  GIFT_TO_YOU = 118,
}

// 促销类型枚举
export const PROMOTYPEENUM = {
  [PROMO_LIST_TYPE.BLACK_MODEL]: '跨店铺大促黑名单模式',
  [PROMO_LIST_TYPE.WHITE_MODEL]: '跨店铺大促白名单模式',
  [PROMO_LIST_TYPE.MARK_MODEL]: '商品打标模式',
  [PROMO_LIST_TYPE.ADVANCE_PRICE_MODEL]: '预告价模式',
  [PROMO_LIST_TYPE.CROSS_SHOP_ACTIVITY]: '跨店铺模式',
  [PROMO_LIST_TYPE.SMART_STOCK_MODEL]: '大促盘货模式',
  [PROMO_LIST_TYPE.PLATFORM_PROMOTION_MODEL]: '平台级促销模式',
  [PROMO_LIST_TYPE.COUPON_MODEL]: '优惠券模式',
  [PROMO_LIST_TYPE.SELF_PROMOTION_MODEL]: '自营总价促销',
  [PROMO_LIST_TYPE.PLUS_BRAND_PROMOTION_MODEL]: '折扣促销',
  [PROMO_LIST_TYPE.EXPANSION_GOLD_MODEL]: '膨胀金',
  [PROMO_LIST_TYPE.PROMO_LIMIT_MODEL]: '限时限量',
  [PROMO_LIST_TYPE.LARGESS_MODEL]: '赠品促销',
  [PROMO_LIST_TYPE.GIFT_TO_YOU]: '送礼折扣',
};

// 搜索筛选条件
export const FORMMAP = [
  {
    key: 'name',
    text: '策略名称',
  },
  {
    key: 'id',
    text: '策略ID',
  },
];
